import { Input, OnInit, OnDestroy, Injector, Injectable } from '@angular/core';
import { EventManager } from '../../../../src/app/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { ConfirmPopUpComponent } from './confirm-popup/confirm-popup.component';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ShortcutService } from '../services/shortcut.service';

@Injectable({ providedIn: 'any' })
export abstract class ChildrenManageComponent implements OnInit, OnDestroy {
  @Input() queryParams: any = {};
  selectedItem: any;
  modalService: any;
  subscriptions?: Subscription[] = [];
  constructor(
    public injector: Injector,
    public eventManager: EventManager,
    public router: Router,
    public linkRoute: string
  ) {
    this.modalService = injector.get(NzModalService);
  }
  ngOnInit() {
    ShortcutService.addOneKey(13, this.loadPage.bind(this, this.queryParams.page));
  }
  ngOnDestroy() {
  }
  loadPage(event: number) {
    this.eventManager.broadcast({
      name: 'load-page',
      content: {
        page: event
      }
    });
  }
  onError() {
    this.queryParams.totalItems = 0;
  }
  trackId(index: number, item: any): number {
    return item.id;
  }
  getValueSearch(event) {
    this.queryParams.searchParams = event;
    const keys = Object.keys(this.queryParams.searchParams);
    keys.forEach((key) => {
      if (typeof this.queryParams.searchParams[key] === 'string') {
        this.queryParams.searchParams[key] = this.queryParams.searchParams[key].trim();
        if (this.queryParams.searchParams[key] === 'undefined' || this.queryParams.searchParams[key] === '') {
          this.queryParams.searchParams[key] = undefined;
        }
      }
    });
    this.loadPage(1);
  }
  eventSearchParams(key, value) {
    this.eventManager.broadcast({
      name: 'add-option-search',
      content: {
        key, value
      }
    });
  }
  create() {
    this.router.navigate([ this.linkRoute + '/create']);
  }
  edit(id) {
    this.router.navigate([this.linkRoute + '/edit/' + id]);
  }
  confirmAction(selectedItem, title?, fowardFunc?) {
    this.selectedItem = selectedItem;
    const modal = this.modalService.create({
      nzTitle: '',
      nzWidth: '650px',
      nzStyle: {top: '20px'},
      nzContent: ConfirmPopUpComponent,
      nzData: {
        title
      },
      nzOnOk: (() => { fowardFunc() })
    });
  }
}
